export default __webpack_public_path__ + "static/media/bosh.3bcb0f6b.png";